var _style, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevOpsIconSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#6B6C6F;}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.935,
    y1: 8.1766,
    x2: 7.935,
    y2: 12.4798,
    gradientTransform: "matrix(1 0 0 -1 0 16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004861"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0367,
    style: {
      stopColor: "#00516C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1846,
    style: {
      stopColor: "#007195"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3366,
    style: {
      stopColor: "#008BB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4916,
    style: {
      stopColor: "#009FD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    style: {
      stopColor: "#00AEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8167,
    style: {
      stopColor: "#00B6ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9F1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,7c0-0.4-0.4-0.8-0.8-0.8c-0.1,0-0.2,0-0.3,0.1c0-0.1,0-0.2,0-0.3c0-0.6-0.5-1.1-1.1-1.1 C9.5,5,9.4,5,9.3,5c0,0,0,0,0-0.1c0-0.8-0.6-1.4-1.4-1.4S6.4,4.2,6.4,5c0,0,0,0,0,0C6.3,5,6.3,5,6.2,5C5.6,5,5.1,5.5,5.1,6.1 c0,0.1,0,0.2,0,0.2c-0.1,0-0.1,0-0.2,0C4.6,6.3,4.2,6.6,4.2,7c0,0.4,0.3,0.7,0.7,0.8v0H11v0C11.4,7.8,11.7,7.4,11.7,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,6.8c0,0.3-0.2,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6C7.8,6.3,8,6.5,8,6.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.355,
    y1: 7.3488,
    x2: 7.355,
    y2: 9.4246,
    gradientTransform: "matrix(1 0 0 -1 0 16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781,
    style: {
      stopColor: "#686869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4973,
    style: {
      stopColor: "#979798"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    style: {
      stopColor: "#B5B4B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0BFC0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.9,6.6C7.9,6.6,7.9,6.6,7.9,6.6c-0.7,0-1.3,0.6-1.3,1.2v0.8h0.4V7.9c0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0 C8,7.1,8,7,8,6.8C8,6.7,8,6.6,7.9,6.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.94,
    y1: 7.3488,
    x2: 8.94,
    y2: 9.4243,
    gradientTransform: "matrix(1 0 0 -1 0 16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781,
    style: {
      stopColor: "#686869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4973,
    style: {
      stopColor: "#979798"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    style: {
      stopColor: "#B5B4B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0BFC0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.7,7.8C8.7,7.9,8.7,7.9,8.7,7.8v0.8h0.4V7.8H8.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.935,
    y1: 4.7522,
    x2: 7.935,
    y2: 7.523,
    gradientTransform: "matrix(1 0 0 -1 0 16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BD571F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAF3D"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.5,10.7c0,0.3-0.2,0.5-0.5,0.5h-2c-0.3,0-0.5-0.2-0.5-0.5V9c0-0.3,0.2-0.5,0.5-0.5h2 c0.3,0,0.5,0.2,0.5,0.5L9.5,10.7L9.5,10.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.935,
    y1: 5.3569,
    x2: 7.935,
    y2: 6.7604,
    gradientTransform: "matrix(1 0 0 -1 0 16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#111F29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#445866"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.3,9.6c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.1,0.1,0.3,0.2,0.3l-0.1,0.7h0.5L8.1,9.9 C8.2,9.9,8.3,9.8,8.3,9.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsIconSecurity);
export default __webpack_public_path__ + "static/media/dev_ops_icon_security.d9c8ec2168b85a2af862bfb6967de989.svg";
export { ForwardRef as ReactComponent };